export const environment = {
  production: true,
  apiUrl: 'https://vhm.dension.com/index.php',
  downloadPath: 'https://vhm.dension.com/',
  mercureUrl: 'https://vhm.dension.com:3000/.well-known/mercure'
};
